import React from 'react';
import { EMAIL_REGEX, TELEGRAM_NAME_REGEX } from './tools';
import ContactsBlock from './FormFields/ContactsBlock';
import PhoneField from './FormFields/PhoneField';
import { TextField } from '@mui/material';
import styles from './styles';
import SlideDownWrapper from '../SlideDownWrapper/SlideDownWrapper';

const inputTypes = {
  text: {
    component: TextField,
    attributes: {
      sx: styles.input,
    },
  },
  email: {
    component: TextField,
    type: 'text',
    attributes: {
      sx: styles.input,
    },
    validation: {
      pattern: {
        value: EMAIL_REGEX,
        message: 'некорректно введенный email',
      },
    },
  },
  howToContact: {
    component: React.forwardRef((props, ref) => (
      <ContactsBlock {...props} forwardedRef={ref} />
    )),
  },
  telegram: {
    component: TextField,
    type: 'text',
    attributes: {
      sx: { width: '100%' },
    },
    validation: {
      pattern: {
        value: TELEGRAM_NAME_REGEX,
        message: 'Введите @username в Telegram',
      },
    },
  },
  phone: {
    component: React.forwardRef((props, ref) => (
      <PhoneField {...props} forwardedRef={ref} />
    )),
    attributes: {
      sx: { width: '100%' },
    },
  },
  slideDown: {
    component: React.forwardRef((props, ref) => {
      return <SlideDownWrapper {...props} forwardedRef={ref} />;
    }),
    attributes: {
      sx: { width: '100%' },
    },
  },
  hidden: {
    component: React.forwardRef((props, ref) => (
      <input ref={ref} type="hidden" />
    )),
  },
};

export default inputTypes;
